// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import React, { useState, useEffect, useRef } from 'react';
import HidePasswordIcon from './assets/hide-password.svg';
import ShowPasswordIcon from './assets/show-password.svg';
import S from './styles';

interface PasswordInputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  error?: string | undefined;
  touched?: boolean | undefined;
  errorAuth?: boolean;
  placeholder: string;
  label: string;
}

const PasswordInput = (props: PasswordInputProps): JSX.Element => {
  const {
    className,
    error,
    touched,
    value,
    errorAuth,
    placeholder,
    label,
    ...otherProps
  } = props;
  const [showPassword, setShowPassword] = useState<boolean>(false);
  const [focus, setFocus] = useState<boolean>();
  const inputRef = useRef<HTMLInputElement>(null);
  const inputContainnerRef = useRef<HTMLDivElement>(null);
  const visibilityRef = useRef<HTMLImageElement>(null);

  useEffect(() => {
    if (!focus) {
      setShowPassword(false);
    }
  }, [focus]);

  const handleBlur = (event: FocusEvent) => {
    const ref = inputRef.current;
    const buttonref = visibilityRef.current;
    console.log(event.target)
    console.log({ buttonref })
    if (!ref?.contains(event.target as Node) && !buttonref?.contains(event.target as Node)) {
      setFocus(false);
      console.log('CLICKED outside box');
      window.removeEventListener('click', handleBlur, true);
    }
  }
  const handleFocus = () => {
    if (!focus) {
      setFocus(true);
      window.addEventListener('click', handleBlur, true);
    }
  }

  return (
    <div className={className}>
      <S.Container error={(!!error && !!touched && !!error)} isFilled={!!value} >
        {!!value && !errorAuth && <S.Label error={!!error && !!touched && !!error}>
          {label}
        </S.Label>}
        <S.InputContainer ref={inputContainnerRef} onClick={handleFocus} >
          <S.Input ref={inputRef} type={showPassword ? 'text' : 'password'} placeholder={placeholder} {...otherProps} />
          <S.ShowPassword ref={visibilityRef} src={showPassword ? ShowPasswordIcon : HidePasswordIcon} onClick={() => { console.log('change onclick'); setShowPassword(!showPassword) }} />
        </S.InputContainer>
      </S.Container>
      {!!error && !!touched && !!error && (<S.ErrorMessage>{error && touched && error}</S.ErrorMessage>)}
    </div>
  );
}

export { PasswordInput as default }
